import { Header } from "components/Header/Header";
import SideBar from "components/SideBar/SideBar";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";

import "./Maincomponent.scss";

const MainComponent = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="main-layout">
      <Header onToggleSidebar={toggleSidebar} sidebarCollapsed={sidebarCollapsed} />
      <div className="main-wrapper">
        <Row className="main-content-row">
          <Col className="main-content-col">
            <div className={`_row ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>
              <div className="_menu_left">
                <SideBar collapsed={sidebarCollapsed} />
              </div>
              <div className="_menu_right">{children}</div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default MainComponent;
